import {
  DefaultCustomLayoutDrawerProps,
  Drawer,
} from 'module/ui/components/atoms/drawer';
import { FC, useMemo } from 'react';
import { AddAiPages, AiPagesPayload } from './ai-pages';

interface Props {
  open: boolean;
  folderName: string;
  onClose: () => void;
  onDone: (payload: AiPagesPayload) => Promise<void>;
}
export const AddAiPagesDrawer: FC<Props> = ({
  open,
  onClose,
  onDone,
  folderName,
}) => {
  const breadcrumbs = useMemo(() => {
    return [
      {
        title: folderName,
        link: '',
      },
    ];
  }, [folderName]);

  return (
    <Drawer
      width="672px"
      open={open}
      onClose={onClose}
      {...DefaultCustomLayoutDrawerProps}
    >
      <AddAiPages onClose={onClose} onNext={onDone} breadcrumbs={breadcrumbs} />
    </Drawer>
  );
};
